import React, { Fragment, useContext, useEffect, useState } from 'react';
import { stickyNav } from 'src/utils';
import { Projects, Services } from './Menu';
import MobileHeader from './MobileHeader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faPhone } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { StaticImage } from 'gatsby-plugin-image';
import { LocalizedLink } from 'gatsby-plugin-i18n-l10n';
import { LayoutDataContext } from '../context/LayoutDataContext';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';

const Header = () => {
  useEffect(() => {
    stickyNav();
  }, []);
  const [navToggle, setNavToggle] = useState(false);

  return (
    <DefaultHeader navToggle={navToggle} setNavToggle={setNavToggle} />
  );
};

export default Header;


const Contact = ({ contact }) => (
    <>
      <p>
        <FontAwesomeIcon icon={faPhone} />{' '}
        <a href={`tel:${contact.phone?.replace(/ /g, '')}`}>{contact.phone}</a>
      </p>
      <p>
        <FontAwesomeIcon icon={faEnvelope} />{' '}
        <a href={`mailto:${contact.email}`}>{contact.email}</a>
      </p>
    </>
  ),
  DefaultHeader = ({ navToggle, setNavToggle }) => {
    const { data } = useContext(LayoutDataContext);
    const contact = data?.strapiContact;

    return (
      <header className="main-header header-four">
        {/* Header-Top */}
        <div className="header-top bg-light-blue text-white">
          <div className="container-fluid">
            <div className="top-inner">
              <div className="top-left">
                {contact && <Contact contact={contact} />}


              </div>
              <div className="top-right d-flex align-items-center">
                <div className="social-style-two">
                  <a href="https://www.linkedin.com/company/cybersecuritylabtech" target="_blank"
                     rel="noreferrer" aria-label="Odwiedź nasz profil na LinkedIn">
                    <FontAwesomeIcon icon={faLinkedin} />
                  </a>
                </div>
                <ul className="top-menu">
                  <li>
                    <LocalizedLink to="/privacy-policy/">Polityka prywatności</LocalizedLink>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* Header-Upper */}
        <div className="header-upper">
          <div className="container-fluid clearfix">
            <div className="header-inner d-flex align-items-center justify-content-between">
              <div className="logo-outer">
                <div className="logo">
                  <LocalizedLink to="/">
                    <img
                      src="/assets/images/logos/csl-logo.svg"
                      alt="Logo CSL Software"
                      height={35}
                    />
                  </LocalizedLink>
                </div>
              </div>
              <div className="nav-outer clearfix">
                {/* Main Menu */}
                <nav className="main-menu navbar-expand-lg">
                  <div className="navbar-header">
                    <div className="mobile-logo">
                      <LocalizedLink to="/">
                        <img
                          src="/assets/images/logos/csl-logo.svg"
                          alt="Logo CSL Software"
                          height={35}
                        />
                      </LocalizedLink>
                    </div>
                    {/* Toggle Button */}
                    <button
                      type="button"
                      className="navbar-toggle"
                      data-toggle="collapse"
                      data-target=".navbar-collapse"
                      aria-label="Otwórz menu nawigacyjne"
                      aria-expanded={navToggle}
                      onClick={() => setNavToggle(!navToggle)}
                    >
                      <span className="sr-only">Menu</span>
                      <span className="icon-bar" />
                      <span className="icon-bar" />
                      <span className="icon-bar" />
                    </button>
                  </div>
                  <div
                    className={`navbar-collapse collapse clearfix ${
                      navToggle ? 'show' : ''
                    }`}
                  >
                    <Menus />
                    <MobileHeader />
                  </div>
                </nav>
                {/* Main Menu End*/}
              </div>
              {/* Menu Button */}
              <div className="menu-btns d-lg-flex d-none align-items-center gap-3">
                <LocalizedLink to="/contact/" className="theme-btn sliding-end">
                  Kontakt
                </LocalizedLink>

                <LocalizedLink to="/eu-funds/">
                  <StaticImage src={'../images/eu/logo-eu.webp'} alt="Flaga Unii Europejskiej" height={46}
                               placeholder="none" />
                </LocalizedLink>
              </div>
            </div>
          </div>
        </div>
        {/*End Header Upper*/}
      </header>
    );
  },
  Menus = () => (
    <ul className="navigation clearfix d-none d-lg-flex">
      <li>
        <LocalizedLink to="/about/">O nas</LocalizedLink>
      </li>
      <li className="dropdown">
        <LocalizedLink to="/#services">Oferta</LocalizedLink>

        <ul>
          <Services />
        </ul>

        <div className="dropdown-btn">
          <span>
            <FontAwesomeIcon icon={faChevronDown} />
          </span>
        </div>
      </li>

      <li className="dropdown">
        <LocalizedLink to="#projects">Realizacje</LocalizedLink>
        <ul>
          <Projects />
        </ul>
        <div className="dropdown-btn">
          <FontAwesomeIcon icon={faChevronDown} />
        </div>
      </li>

      <li className="dropdown">
        <LocalizedLink to="/career/">Kariera</LocalizedLink>
      </li>

      <li className="dropdown">
        <LocalizedLink to="/blog/">Blog</LocalizedLink>
      </li>
    </ul>
  );
